import React from "react";
import classnames from "classnames";
import { Checkbox } from "@common/checkbox";
import { FolderIcon } from "@common/folderIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Project(props: Props) {
  return (
    <div className={styles.project}>
      <label
        className={classnames(styles.label, {
          [styles.selectedProject]: props.isProjectSelected,
        })}
        onClick={() =>
          props.isProjectSelected
            ? props.unSelectProject(props.project)
            : props.selectProject(props.project)
        }
      >
        <Checkbox isChecked={props.isProjectSelected} />
        <FolderIcon className={styles.folderIcon} />
        <span>{props.project.name}</span>
      </label>
    </div>
  );
}
export { Project };
